export const TOKEN_STORAGE_KEY = 'onyx_token';
export const EMPLOYEE_STORAGE_KEY = 'onyx_employee';

export const config = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL || 'https://api.onyxpay.biz').replace(/\/$/, ''),
  /** Public pay portal — for invoice link preview in Cargo admin */
  invoicePayBaseUrl: (
    import.meta.env.VITE_INVOICE_PAY_BASE_URL || 'https://pay.onyxpay.biz'
  ).replace(/\/$/, ''),
};
